import jQuery from 'jquery'

;(function ($, window, document, undefined) {
  var _window = $(window)

  $(function () {
    function scroll() {
      var headerHight = 100
      $('a[href^="#"]').click(function () {
        var href = $(this).attr('href')

        var target = $(href == '#' || href == '' ? 'html' : href)

        var position = target.offset().top - headerHight
        $('html, body').animate({ scrollTop: position }, 500)
        return false
      })
    }
    function page_top() {
      var topBtn = $('.page-top')
      topBtn.hide()
      //スクロールが100に達したらボタン表示
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          topBtn.fadeIn()
        } else {
          topBtn.fadeOut()
        }
      })
      //スクロールしてトップ
      topBtn.click(function () {
        $('body,html').animate(
          {
            scrollTop: 0,
          },
          500,
        )
        return false
      })
    }

    function ani() {
      $(
        '.anim-fade-1, .anim-fade-2, .anim-fade-3, .anim-fade-4, .anim-fade-5, .anim-blur-1, .anim-blur-2, .anim-blur-3, .anim-blur-4, .anim-blur-5, .anim-concept-pic-1, .anim-concept-pic-2',
      ).on('inview', function (event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
          $(this).stop().addClass('anim-start')
        } else {
          //$(this).stop().removeClass('anim-start');
        }
      })
    }

    function tabs() {
      $('.list-tab > li').click(function () {
        var num = $('.list-tab > li').index(this)
        $('.list-tab > li').removeClass('is-active')
        $('.list-tab-bottom > li').removeClass('is-active')
        $(this).addClass('is-active')
        $('.list-tab-bottom > li').eq(num).addClass('is-active')
        $('.tab').removeClass('is-active').hide()
        $('.tab').eq(num).addClass('is-active').show()
      })
      $('.list-tab-bottom > li').click(function () {
        var num = $('.list-tab-bottom > li').index(this)
        $('.list-tab-bottom > li').removeClass('is-active')
        $('.list-tab > li').removeClass('is-active')
        $(this).addClass('is-active')
        $('.list-tab > li').eq(num).addClass('is-active')
        $('.tab').removeClass('is-active').hide()
        $('.tab').eq(num).addClass('is-active').show()
        $('body,html').animate(
          {
            scrollTop: 0,
          },
          500,
        )
        return false
      })
    }
    function cor() {
      $('.main-cor .main-cor-title').click(function () {
        $(this).toggleClass('is-active')

        $(this).next('.main-cor-content').slideToggle()
      })
    }

    function sp() {}

    jQuery(document).ready(function ($) {
      $(document).ready(function () {
        ani()

        //mouse();
        //mouse2();
        cor()
        page_top()
        sp()
        tabs()
        scroll()
      })
    })
  })
})(jQuery, window, window.document)
